import logoIcon from './assets/logo/logo-icon.webp';
import logoIconWhite from './assets/logo/logo-icon-white.png';
import logoWithBrand from './assets/logo/logo-full.webp';
import logoWithBrandWhite from './assets/logo/logo-full-white.png';
import logoWithBrandSlogun from './assets/logo/logo-full-slogun.png';
import logoWithBrandSlogunWhite from './assets/logo/logo-full-slogun-white.png';
import authLogoTagline from './assets/logo/logo-auth-tagline.png';
import authLogoTaglineWhite from './assets/logo/logo-auth-tagline-white.png';
// import logoWithBrandSlogun from './assets/logo/ANTE1.png';
// import loginBackground from './assets/imgs/bg.jpg';
// import loginBackground from './assets/imgs/HomeBG2-1.png';
import errorIcon1 from './assets/imgs/Robot2-500.png';
import antSearchPageBackground from './assets/imgs/auth/search-page-logo-horizontal.webp';
// import searchPageBackground from './assets/imgs/ANTE1.png';
import searchPageBackground from './assets/imgs/ANTE6-500.png';
// Bộ minh hoạ chibi dùng chung (nguồn: scripts/design-gen/empty-icons) — nền empty theo ý nghĩa màn.
import emptyOrder from './assets/imgs/empty/empty_order.png';
import emptyProduct from './assets/imgs/empty/empty_product.png';
import emptyCustomer from './assets/imgs/empty/empty_customer.png';
import emptyTask from './assets/imgs/empty/empty_task.png';
import emptyChat from './assets/imgs/empty/empty_chat.png';
import emptyTable from './assets/imgs/empty/empty_table.png';
import emptyCooking from './assets/imgs/empty/empty_cooking.png';
import emptyAppointment from './assets/imgs/empty/empty_appointment.png';
import emptyGeneric from './assets/imgs/empty/empty_generic.png';
import emptyDefault from './assets/imgs/empty/empty_default.webp';
import posEmpty from './assets/imgs/empty/pos_empty.png';
import emptyPayment from './assets/imgs/empty/empty_payment.png';
import emptyPurchase from './assets/imgs/empty/empty_purchase.png';
import emptyDelivery from './assets/imgs/empty/empty_delivery.png';
import emptyReport from './assets/imgs/empty/empty_report.png';
import emptyEmployee from './assets/imgs/empty/empty_employee.webp';
import emptyQuicksale from './assets/imgs/empty/empty_quicksale.png';
import emptyInvoice from './assets/imgs/empty/empty_invoice.png';
import emptyReturn from './assets/imgs/empty/empty_return.png';
import emptyPricelist from './assets/imgs/empty/empty_pricelist.png';
import emptyPromotion from './assets/imgs/empty/empty_promotion.png';
// import anteMaster from './assets/imgs/ante-master.png';
// import loginLeftImage from './assets/imgs/ANTE2.png';

import loginBackground0 from './assets/imgs/bg4-2-3.webp';
// import loginBackground1 from './assets/imgs/bg1.jpg';
// import loginBackground2 from './assets/imgs/HomeBG2.jpg';
// import loginBackground3 from './assets/imgs/HomeBG4.jpg';
// import loginBackground5 from './assets/imgs/HomeBG5.jpg';
// import loginBackground6 from './assets/imgs/HomeBG6.jpg';
// import loginBackground7 from './assets/imgs/bg7-2-3.png';
// import loginBackground10 from './assets/imgs/HomeBG10-3.png';
import loginBackground11 from './assets/imgs/HomeBG11-3.webp';
// import loginBackground15 from './assets/imgs/HomeBG15-3.png';
// import loginBackground16 from './assets/imgs/HomeBG16-3.png';
// import loginBackground17 from './assets/imgs/HomeBG17.jpg';
// import loginBackground18 from './assets/imgs/HomeBG18.jpg';
// import loginBackground19 from './assets/imgs/HomeBG19.jpg';
// import posBackground from './assets/imgs/POSHomeBG2.png';

import loginBackgroundNew1 from './assets/imgs/BG-Login-1.webp';
import loginBackgroundNew2 from './assets/imgs/BG-Login-2.webp';
import loginBackgroundNew3 from './assets/imgs/BG-Login-3.webp';
import loginBackgroundNew4 from './assets/imgs/BG-Login-4.webp';
import loginBackgroundNew5 from './assets/imgs/BG-Login-5.webp';
import loginBackgroundNew6 from './assets/imgs/BG-Login-6.webp';
import loginBackgroundNew7 from './assets/imgs/BG-Login-7.webp';
import loginBackgroundNew8 from './assets/imgs/BG-Login-8.webp';
import loginBackgroundNew9 from './assets/imgs/BG-Login-9.webp';
import loginBackgroundNew10 from './assets/imgs/BG-Login-10.webp';
import loginBackgroundNew11 from './assets/imgs/BG-Login-11.webp';
import loginBackgroundNew12 from './assets/imgs/BG-Login-12.webp';
import loginBackgroundNew13 from './assets/imgs/BG-Login-13.webp';
import loginBackgroundNew15 from './assets/imgs/BG-Login-15.webp';
import loginBackgroundNew16 from './assets/imgs/BG-Login-16.webp';
import loginBackgroundNew17 from './assets/imgs/BG-Login-17.webp';
import loginBackgroundNew18 from './assets/imgs/BG-Login-18.webp';
import loginBackgroundNew19 from './assets/imgs/BG-Login-19.webp';
import loginBackgroundNew20 from './assets/imgs/BG-Login-20.webp';
import loginBackgroundNew21 from './assets/imgs/BG-Login-21.webp';
import loginBackgroundNew22 from './assets/imgs/BG-Login-22.webp';
import loginBackgroundNew23 from './assets/imgs/BG-Login-23.webp';
import loginBackgroundNew24 from './assets/imgs/BG-Login-24.webp';
import loginBackgroundNew25 from './assets/imgs/BG-Login-25.webp';

export default {
    logoWithBrand: logoWithBrand,
    logoWithBrandWhite: logoWithBrandWhite,
    logoWithBrandSlogun: logoWithBrandSlogun,
    logoWithBrandSlogunWhite: logoWithBrandSlogunWhite,
    authLogoTagline: authLogoTagline,
    authLogoTaglineWhite: authLogoTaglineWhite,
    logoOnly: logoIcon,
    logoOnlyWhite: logoIconWhite,
    loginBackground: loginBackground0,
    // posBackground: loginBackground11,
    posBackground: loginBackgroundNew25,//loginBackgroundNew19,
    loginBackgrounds: [
        // loginBackground0,
        // loginBackground11,
        // loginBackgroundNew2,
        loginBackgroundNew3,
        loginBackgroundNew4,
        loginBackgroundNew5,
        loginBackgroundNew5,
        loginBackgroundNew5,
        loginBackgroundNew5,
        loginBackgroundNew6,
        loginBackgroundNew6,
        loginBackgroundNew6,
        loginBackgroundNew6,
        loginBackgroundNew6,
        loginBackgroundNew7,
        loginBackgroundNew7,
        loginBackgroundNew8,
        loginBackgroundNew8,
        loginBackgroundNew8,
        loginBackgroundNew8,
        loginBackgroundNew9,
        loginBackgroundNew9,
        loginBackgroundNew9,
        loginBackgroundNew9,
        loginBackgroundNew9,
        // loginBackgroundNew10,
        // loginBackgroundNew11,
        loginBackgroundNew12,
        loginBackgroundNew12,
        loginBackgroundNew12,
        loginBackgroundNew12,
        // loginBackgroundNew13,
        // loginBackgroundNew14,
        loginBackgroundNew15,
        loginBackgroundNew16,
        loginBackgroundNew16,
        loginBackgroundNew16,
        loginBackgroundNew16,
        loginBackgroundNew17,
        loginBackgroundNew17,
        loginBackgroundNew17,
        loginBackgroundNew18,
        loginBackgroundNew25,
        loginBackgroundNew25,
        loginBackgroundNew25,
        loginBackgroundNew25,
        loginBackgroundNew25,
        loginBackgroundNew25,
        loginBackgroundNew25,
        // loginBackgroundNew20,
        // loginBackgroundNew21,
        // loginBackgroundNew22,
        loginBackgroundNew23,
        // loginBackgroundNew24,
    ],
    // loginLeftImage: anteMaster,
    antSearchPageBackground: antSearchPageBackground,
    searchPageBackground: searchPageBackground,
    errorIcon1: errorIcon1,
    empty_order: emptyOrder,
    empty_product: emptyProduct,
    empty_customer: emptyCustomer,
    empty_task: emptyTask,
    empty_chat: emptyChat,
    empty_table: emptyTable,
    empty_cooking: emptyCooking,
    empty_appointment: emptyAppointment,
    empty_generic: emptyGeneric,
    empty_default: emptyDefault,
    pos_empty: posEmpty,
    empty_payment: emptyPayment,
    empty_purchase: emptyPurchase,
    empty_delivery: emptyDelivery,
    empty_report: emptyReport,
    empty_employee: emptyEmployee,
    empty_quicksale: emptyQuicksale,
    empty_invoice: emptyInvoice,
    empty_return: emptyReturn,
    empty_pricelist: emptyPricelist,
    empty_promotion: emptyPromotion,
};
